module.exports = __webpack_public_path__ + "img/@logo_arena.24bf7214.jpg";